/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { billing_AnnualConfirmationFinalizeRequest } from '../models/billing_AnnualConfirmationFinalizeRequest';
import type { billing_AnnualConfirmationReopenRequest } from '../models/billing_AnnualConfirmationReopenRequest';
import type { billing_AnnualConfirmationResponse } from '../models/billing_AnnualConfirmationResponse';
import type { reconciliation_ApplicationListResponse } from '../models/reconciliation_ApplicationListResponse';
import type { reconciliation_ApplyCreditRequest } from '../models/reconciliation_ApplyCreditRequest';
import type { reconciliation_ApplyPaymentRequest } from '../models/reconciliation_ApplyPaymentRequest';
import type { reconciliation_ApplySubsidyPaymentRequest } from '../models/reconciliation_ApplySubsidyPaymentRequest';
import type { reconciliation_ApplySubsidyPaymentResponse } from '../models/reconciliation_ApplySubsidyPaymentResponse';
import type { reconciliation_AttachSubsidyOfficeReportPaymentRequest } from '../models/reconciliation_AttachSubsidyOfficeReportPaymentRequest';
import type { reconciliation_CandidateListResponse } from '../models/reconciliation_CandidateListResponse';
import type { reconciliation_ConfirmReviewItemRequest } from '../models/reconciliation_ConfirmReviewItemRequest';
import type { reconciliation_CorrectionDTO } from '../models/reconciliation_CorrectionDTO';
import type { reconciliation_CorrectionListResponse } from '../models/reconciliation_CorrectionListResponse';
import type { reconciliation_CreateCorrectionRequest } from '../models/reconciliation_CreateCorrectionRequest';
import type { reconciliation_CreateDebtorAccountRequest } from '../models/reconciliation_CreateDebtorAccountRequest';
import type { reconciliation_CreateManualPaymentRequest } from '../models/reconciliation_CreateManualPaymentRequest';
import type { reconciliation_CreateRuleRequest } from '../models/reconciliation_CreateRuleRequest';
import type { reconciliation_CreditedReviewQueueListResponse } from '../models/reconciliation_CreditedReviewQueueListResponse';
import type { reconciliation_DebtorAccountAggregatesResponse } from '../models/reconciliation_DebtorAccountAggregatesResponse';
import type { reconciliation_DebtorAccountByChildResponse } from '../models/reconciliation_DebtorAccountByChildResponse';
import type { reconciliation_DebtorAccountDetailResponse } from '../models/reconciliation_DebtorAccountDetailResponse';
import type { reconciliation_DebtorAccountDTO } from '../models/reconciliation_DebtorAccountDTO';
import type { reconciliation_DebtorAccountListResponse } from '../models/reconciliation_DebtorAccountListResponse';
import type { reconciliation_DebtorAccountsSummaryResponse } from '../models/reconciliation_DebtorAccountsSummaryResponse';
import type { reconciliation_DebtorAnalyticsResponse } from '../models/reconciliation_DebtorAnalyticsResponse';
import type { reconciliation_DebtorCreditBatchResponse } from '../models/reconciliation_DebtorCreditBatchResponse';
import type { reconciliation_DebtorIbansResponse } from '../models/reconciliation_DebtorIbansResponse';
import type { reconciliation_DebtorInvoiceCoverageResponse } from '../models/reconciliation_DebtorInvoiceCoverageResponse';
import type { reconciliation_DebtorLedgerResponse } from '../models/reconciliation_DebtorLedgerResponse';
import type { reconciliation_DebtorMonthlySeriesResponse } from '../models/reconciliation_DebtorMonthlySeriesResponse';
import type { reconciliation_DebtorPaymentRegisterResponse } from '../models/reconciliation_DebtorPaymentRegisterResponse';
import type { reconciliation_DebtorPeriodSummaryResponse } from '../models/reconciliation_DebtorPeriodSummaryResponse';
import type { reconciliation_DuplicateRevertResponse } from '../models/reconciliation_DuplicateRevertResponse';
import type { reconciliation_FlattenApplyRequest } from '../models/reconciliation_FlattenApplyRequest';
import type { reconciliation_FlattenBatchResultResponse } from '../models/reconciliation_FlattenBatchResultResponse';
import type { reconciliation_FlattenPlanResponse } from '../models/reconciliation_FlattenPlanResponse';
import type { reconciliation_FlattenRevertRequest } from '../models/reconciliation_FlattenRevertRequest';
import type { reconciliation_GenerateMissingInvoicesRequest } from '../models/reconciliation_GenerateMissingInvoicesRequest';
import type { reconciliation_GenerateMissingInvoicesResponse } from '../models/reconciliation_GenerateMissingInvoicesResponse';
import type { reconciliation_IgnoreReviewItemRequest } from '../models/reconciliation_IgnoreReviewItemRequest';
import type { reconciliation_ImportBatchDetailResponse } from '../models/reconciliation_ImportBatchDetailResponse';
import type { reconciliation_ImportBatchListResponse } from '../models/reconciliation_ImportBatchListResponse';
import type { reconciliation_ImportBatchResponse } from '../models/reconciliation_ImportBatchResponse';
import type { reconciliation_InvoiceCorrectionListResponse } from '../models/reconciliation_InvoiceCorrectionListResponse';
import type { reconciliation_ManualRefundResponse } from '../models/reconciliation_ManualRefundResponse';
import type { reconciliation_MarkAsSubsidyRequest } from '../models/reconciliation_MarkAsSubsidyRequest';
import type { reconciliation_MarkAsSubsidyResponse } from '../models/reconciliation_MarkAsSubsidyResponse';
import type { reconciliation_MatchingRuleDTO } from '../models/reconciliation_MatchingRuleDTO';
import type { reconciliation_MatchingRuleListResponse } from '../models/reconciliation_MatchingRuleListResponse';
import type { reconciliation_MissingInvoicesResponse } from '../models/reconciliation_MissingInvoicesResponse';
import type { reconciliation_MoveSubsidyPaymentListResponse } from '../models/reconciliation_MoveSubsidyPaymentListResponse';
import type { reconciliation_MoveSubsidyPaymentPreviewResponse } from '../models/reconciliation_MoveSubsidyPaymentPreviewResponse';
import type { reconciliation_MoveSubsidyPaymentRequest } from '../models/reconciliation_MoveSubsidyPaymentRequest';
import type { reconciliation_MoveSubsidyPaymentResultResponse } from '../models/reconciliation_MoveSubsidyPaymentResultResponse';
import type { reconciliation_MoveSubsidyPaymentRevertRequest } from '../models/reconciliation_MoveSubsidyPaymentRevertRequest';
import type { reconciliation_NetOfficeReclaimRequest } from '../models/reconciliation_NetOfficeReclaimRequest';
import type { reconciliation_NetOfficeReclaimResponse } from '../models/reconciliation_NetOfficeReclaimResponse';
import type { reconciliation_OfficeReclaimRevertResponse } from '../models/reconciliation_OfficeReclaimRevertResponse';
import type { reconciliation_OrgMonthlyTrendResponse } from '../models/reconciliation_OrgMonthlyTrendResponse';
import type { reconciliation_PaymentDetailResponse } from '../models/reconciliation_PaymentDetailResponse';
import type { reconciliation_PaymentDTO } from '../models/reconciliation_PaymentDTO';
import type { reconciliation_PaymentListResponse } from '../models/reconciliation_PaymentListResponse';
import type { reconciliation_PaymentMatchingRulesResponse } from '../models/reconciliation_PaymentMatchingRulesResponse';
import type { reconciliation_PaymentRegisterResponse } from '../models/reconciliation_PaymentRegisterResponse';
import type { reconciliation_PendingSubsidyPaymentListResponse } from '../models/reconciliation_PendingSubsidyPaymentListResponse';
import type { reconciliation_ReconciliationMetricsResponse } from '../models/reconciliation_ReconciliationMetricsResponse';
import type { reconciliation_ReleasePaymentRequest } from '../models/reconciliation_ReleasePaymentRequest';
import type { reconciliation_ReleasePaymentResponse } from '../models/reconciliation_ReleasePaymentResponse';
import type { reconciliation_RevertApplicationRequest } from '../models/reconciliation_RevertApplicationRequest';
import type { reconciliation_RevertBatchResponse } from '../models/reconciliation_RevertBatchResponse';
import type { reconciliation_RevertCorrectionRequest } from '../models/reconciliation_RevertCorrectionRequest';
import type { reconciliation_RevertCreditedRequest } from '../models/reconciliation_RevertCreditedRequest';
import type { reconciliation_RevertResponse } from '../models/reconciliation_RevertResponse';
import type { reconciliation_RevertSubsidyApplicationRequest } from '../models/reconciliation_RevertSubsidyApplicationRequest';
import type { reconciliation_SearchReconciliationResponse } from '../models/reconciliation_SearchReconciliationResponse';
import type { reconciliation_SetSubsidyOfficeChildRefRequest } from '../models/reconciliation_SetSubsidyOfficeChildRefRequest';
import type { reconciliation_SetSubsidyOfficeReportLineChildRequest } from '../models/reconciliation_SetSubsidyOfficeReportLineChildRequest';
import type { reconciliation_StichprobePackDownloadResponse } from '../models/reconciliation_StichprobePackDownloadResponse';
import type { reconciliation_SubsidyChildTotalsResponseDTO } from '../models/reconciliation_SubsidyChildTotalsResponseDTO';
import type { reconciliation_SubsidyLedgerMonthlyResponseDTO } from '../models/reconciliation_SubsidyLedgerMonthlyResponseDTO';
import type { reconciliation_SubsidyLedgerResponseDTO } from '../models/reconciliation_SubsidyLedgerResponseDTO';
import type { reconciliation_SubsidyObligationListResponse } from '../models/reconciliation_SubsidyObligationListResponse';
import type { reconciliation_SubsidyOfficeChildRefListResponse } from '../models/reconciliation_SubsidyOfficeChildRefListResponse';
import type { reconciliation_SubsidyOfficeReportDetailResponse } from '../models/reconciliation_SubsidyOfficeReportDetailResponse';
import type { reconciliation_SubsidyOfficeReportListResponse } from '../models/reconciliation_SubsidyOfficeReportListResponse';
import type { reconciliation_SubsidyOfficeSummaryResponseDTO } from '../models/reconciliation_SubsidyOfficeSummaryResponseDTO';
import type { reconciliation_SubsidyRoundingAdoptionResponse } from '../models/reconciliation_SubsidyRoundingAdoptionResponse';
import type { reconciliation_SubsidyStatementQueueResponse } from '../models/reconciliation_SubsidyStatementQueueResponse';
import type { reconciliation_SubsidyUnappliedCreditResponseDTO } from '../models/reconciliation_SubsidyUnappliedCreditResponseDTO';
import type { reconciliation_UpdateDebtorAccountRequest } from '../models/reconciliation_UpdateDebtorAccountRequest';
import type { reconciliation_UpdateDunningExclusionRequest } from '../models/reconciliation_UpdateDunningExclusionRequest';
import type { reconciliation_UpdateRuleRequest } from '../models/reconciliation_UpdateRuleRequest';
import type { reconciliation_WriteOffSubsidyRemainderRequest } from '../models/reconciliation_WriteOffSubsidyRemainderRequest';
import type { reconciliation_WriteOffSubsidyRemainderResponse } from '../models/reconciliation_WriteOffSubsidyRemainderResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ReconciliationService {
    /**
     * Revert an account-direct correction
     * Backs out a previously created correction. For invoice-targeted corrections the invoice split paid_amount is decremented and the invoice status is recomputed so the invoice re-opens. Idempotent guard: returns 422 when the correction is already reverted.
     * @param id Correction ID
     * @param request Optional revert reason
     * @returns reconciliation_CorrectionDTO OK
     * @throws ApiError
     */
    public static postApiV1ReconciliationCorrectionsRevert(
        id: string,
        request?: reconciliation_RevertCorrectionRequest,
    ): CancelablePromise<reconciliation_CorrectionDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/corrections/{id}/revert',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Invalid ID`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Correction not found`,
                422: `Invalid revert input (e.g. already reverted)`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * List debtor accounts
     * Paginated list of debtor accounts enriched with per-row aggregates (open invoice count, total outstanding, net balance, last payment date). Supports has_credit, has_outstanding, and ILIKE search filters.
     * @param hasCredit Restrict to debtors with (true) or without (false) unapplied credit
     * @param hasOutstanding Restrict to debtors with (true) or without (false) positive outstanding aggregate
     * @param hasNegativeBalance Restrict to debtors whose Net Balance is negative (total_received_cents - total_invoiced_cents < 0). Same predicate the Net balance column renders, so the filter and the column never disagree. Used by the billing-dashboard 'Negative Accounts' surfaces.
     * @param search ILIKE search across the user-visible debtor label only: family_groups.family_name (household lead), contacts.firstname/lastname (contact lead), and attached children's child_internal_id/firstname/lastname. display_name, contact email and bank IBANs are intentionally NOT searched (max 255 chars)
     * @param sort Optional sort column: name | outstanding | credit | net | last_payment. Unknown values are ignored (default order = display_name ASC). The money sorts (outstanding/credit/net/last_payment) force the full aggregate query path.
     * @param order Sort direction: asc | desc (default asc when a valid sort column is given; ignored otherwise)
     * @param lifecycle Filter by debtor-account lifecycle: current (active — a subsidy office, or a family/contact with at least one child on a current or upcoming contract) | left (departed — no such contract) | all. Unknown or absent values apply no restriction (all).
     * @param limit Page size (1-100, default 20)
     * @param offset Skip count (default 0)
     * @param agingBucket Keep debtors with a positive open amount in one aging bucket, by days overdue as of today (the buckets of /debtor-accounts/aggregates): current (not yet due) | d1_30 | d31_60 | d61_90 | d90plus | overdue (any past-due bucket). Forces the full aggregate path; total_count counts the filtered set.
     * @param include Comma-separated extras for the page's debtors: aggregates (the payload of /debtor-accounts/aggregates) and/or series (the payload of /debtor-accounts/monthly-series), so a table paints names and money from one request. Unknown values are a 400.
     * @returns reconciliation_DebtorAccountListResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationDebtorAccounts(
        hasCredit?: boolean,
        hasOutstanding?: boolean,
        hasNegativeBalance?: boolean,
        search?: string,
        sort?: string,
        order?: string,
        lifecycle?: 'current' | 'left' | 'all',
        limit?: number,
        offset?: number,
        agingBucket?: 'current' | 'd1_30' | 'd31_60' | 'd61_90' | 'd90plus' | 'overdue',
        include?: string,
    ): CancelablePromise<reconciliation_DebtorAccountListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/debtor-accounts',
            query: {
                'has_credit': hasCredit,
                'has_outstanding': hasOutstanding,
                'has_negative_balance': hasNegativeBalance,
                'search': search,
                'sort': sort,
                'order': order,
                'lifecycle': lifecycle,
                'limit': limit,
                'offset': offset,
                'aging_bucket': agingBucket,
                'include': include,
            },
            errors: {
                400: `Invalid query parameter`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Create a debtor account
     * Manually creates a debtor row pointing at exactly one of family_group_id, contact_id, or subsidy_office_id. The three target FKs are immutable post-creation.
     * @param request create payload
     * @returns reconciliation_DebtorAccountDTO Created
     * @throws ApiError
     */
    public static postApiV1ReconciliationDebtorAccounts(
        request: reconciliation_CreateDebtorAccountRequest,
    ): CancelablePromise<reconciliation_DebtorAccountDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/debtor-accounts',
            body: request,
            errors: {
                400: `validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `uniqueness violation`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Archive (soft-delete) a debtor account
     * Soft-deletes the debtor_account. Fails with HTTP 409 when the account still carries unapplied credit; record a refund payment first (§13.4).
     * @param id Debtor account ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1ReconciliationDebtorAccounts(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/reconciliation/debtor-accounts/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid ID`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Debtor account not found`,
                409: `Debtor has non-zero unapplied credit`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Get debtor account detail (account + open invoices)
     * Returns one debtor account plus its open invoice splits. The slide-over opens on these two, so they are fetched eagerly; the full-lifetime ledger and the payer IBANs have moved to their own lazy per-tab endpoints (GET .../ledger, GET .../ibans).
     * @param id Debtor account ID
     * @returns reconciliation_DebtorAccountDetailResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationDebtorAccounts1(
        id: string,
    ): CancelablePromise<reconciliation_DebtorAccountDetailResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/debtor-accounts/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid ID`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Debtor account not found`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Update a debtor account (display_name only)
     * Updates the display name. The three target FKs are immutable post-creation; the DTO doesn't expose them and any attempt is rejected as a 400.
     * @param id Debtor account ID
     * @param request patch payload
     * @returns reconciliation_DebtorAccountDTO OK
     * @throws ApiError
     */
    public static patchApiV1ReconciliationDebtorAccounts(
        id: string,
        request: reconciliation_UpdateDebtorAccountRequest,
    ): CancelablePromise<reconciliation_DebtorAccountDTO> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/reconciliation/debtor-accounts/{id}',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Debtor ledger summed per month, for the detail charts
     * Sums the debtor's whole ledger feed (the rows of GET /debtor-accounts/{id}/ledger) per calendar month in the organisation's time zone: invoicedCents = finalized invoices, receivedCents = received payments, correctionCents = account corrections and their reversals (signed). Every entry type opens its month, so the first month is the first month of the feed. Months without activity are omitted. Powers the balance bridge, running balance and payment heatmap of the debtor detail in one request instead of the whole ledger. An unknown or cross-tenant id returns no months.
     * @param id Debtor account ID
     * @returns reconciliation_DebtorAnalyticsResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationDebtorAccountsAnalytics(
        id: string,
    ): CancelablePromise<reconciliation_DebtorAnalyticsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/debtor-accounts/{id}/analytics',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid ID`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Get a debtor account's annual confirmation numbers
     * Returns the calendar years with an annual confirmation and, for the given year, one letter per child of a parent debtor account (contact or family group): the account's share per month, the status (DRAFT live, FINAL from the snapshot), who finalized it and whether the live figures changed since. Care amount = invoice total minus course line items and, unless the organisation includes them, the additional services; extra care days always count. Eligible statuses: finalized, sent, paid, partial, overdue, credited. Subsidy-office accounts answer 422 NOT_A_PARENT_DEBTOR.
     * @param id Debtor account ID
     * @param year Calendar year
     * @returns billing_AnnualConfirmationResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationDebtorAccountsAnnualConfirmation(
        id: string,
        year?: number,
    ): CancelablePromise<billing_AnnualConfirmationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/debtor-accounts/{id}/annual-confirmation',
            path: {
                'id': id,
            },
            query: {
                'year': year,
            },
            errors: {
                400: `Invalid id or year`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Debtor account not found`,
                422: `Not a parent debtor account (NOT_A_PARENT_DEBTOR)`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Finalize children's annual confirmation
     * Freezes the annual confirmation of the given children of a parent debtor account for one year (#1975): the figures of every payer of each child are stored as a snapshot, and parents can download the letter from then on. Already finalized children are skipped. The year may be the current one. Returns the account's confirmation of that year.
     * @param id Debtor account ID
     * @param body Year and children
     * @returns billing_AnnualConfirmationResponse OK
     * @throws ApiError
     */
    public static postApiV1ReconciliationDebtorAccountsAnnualConfirmationFinalize(
        id: string,
        body: billing_AnnualConfirmationFinalizeRequest,
    ): CancelablePromise<billing_AnnualConfirmationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/debtor-accounts/{id}/annual-confirmation/finalize',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Invalid id, year or child ids`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Debtor account not found`,
                422: `Subsidy office (NOT_A_PARENT_DEBTOR) or child not on the account (ANNUAL_CONFIRMATION_CHILD_NOT_ON_ACCOUNT)`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Download a debtor account's annual confirmation PDF
     * Renders the annual confirmation (Jahresbestaetigung) letters of a parent debtor account for a calendar year, one page per child. A finalized child renders from its snapshot; a draft renders live with a diagonal "ENTWURF / DRAFT" watermark. child_id narrows to one letter.
     * @param id Debtor account ID
     * @param year Calendar year
     * @param childId One child's letter only
     * @param lang Language (de, en, fr, it, es, pt)
     * @returns binary PDF file
     * @throws ApiError
     */
    public static getApiV1ReconciliationDebtorAccountsAnnualConfirmationPdf(
        id: string,
        year: number,
        childId?: string,
        lang?: string,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/debtor-accounts/{id}/annual-confirmation/pdf',
            path: {
                'id': id,
            },
            query: {
                'year': year,
                'child_id': childId,
                'lang': lang,
            },
            errors: {
                400: `Missing or invalid id, year, child_id or language`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Debtor account not found or no invoices for this year (NO_INVOICES_FOR_YEAR)`,
                422: `Not a parent debtor account (NOT_A_PARENT_DEBTOR)`,
                500: `Failed to generate annual confirmation`,
            },
        });
    }
    /**
     * Reopen a finalized annual confirmation
     * Turns one finalized child-year of a parent debtor account back to draft (#1975, admins only). The reason is required and written to the audit trail; parents no longer see the letter until it is finalized again. Returns the account's confirmation of that year.
     * @param id Debtor account ID
     * @param body Year, child and reason
     * @returns billing_AnnualConfirmationResponse OK
     * @throws ApiError
     */
    public static postApiV1ReconciliationDebtorAccountsAnnualConfirmationReopen(
        id: string,
        body: billing_AnnualConfirmationReopenRequest,
    ): CancelablePromise<billing_AnnualConfirmationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/debtor-accounts/{id}/annual-confirmation/reopen',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Invalid id, year, child id or reason`,
                401: `Unauthorized`,
                403: `Admin access required`,
                404: `Debtor account not found`,
                409: `Not finalized (ANNUAL_CONFIRMATION_NOT_FINAL)`,
                422: `Subsidy office (NOT_A_PARENT_DEBTOR) or child not on the account (ANNUAL_CONFIRMATION_CHILD_NOT_ON_ACCOUNT)`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Apply unapplied credit to specific open invoices
     * Consumes the debtor's `unapplied_credit_cents` against the user-picked list of open invoice splits in a single atomic transaction. The service walks the debtor's outstanding source payments FIFO (oldest bank_transactions.value_date first) and writes one payment_applications row per slice tagged `manual_credit_apply`. Each application decrements the debtor's credit balance and the source payment's `unapplied_amount_cents`, and the touched invoices are recomputed so split / invoice statuses transition (e.g. `pending` → `paid`). Rejects with 400 when the supplied splits do not belong to the path debtor or when the requested total exceeds the available credit.
     * @param id Debtor account ID
     * @param request Applications payload
     * @returns void
     * @throws ApiError
     */
    public static postApiV1ReconciliationDebtorAccountsApplyCredit(
        id: string,
        request: reconciliation_ApplyCreditRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/debtor-accounts/{id}/apply-credit',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Invalid input (over-apply, unknown split, etc.)`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Debtor account not found`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * List corrections for a debtor account
     * Returns all account-direct corrections for the given debtor account, ordered newest first.
     * @param id Debtor account ID
     * @returns reconciliation_CorrectionListResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationDebtorAccountsCorrections(
        id: string,
    ): CancelablePromise<reconciliation_CorrectionListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/debtor-accounts/{id}/corrections',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid ID`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Debtor account not found`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Create an account-direct correction
     * Posts a signed ledger adjustment directly to a debtor account. A negative amountCents is a credit (reduces what the debtor owes); a positive amountCents is a charge. When invoiceId, invoiceSplitId, and invoiceYear are all provided, the correction also settles the target invoice split.
     * @param id Debtor account ID
     * @param request Correction payload
     * @returns reconciliation_CorrectionDTO Created
     * @throws ApiError
     */
    public static postApiV1ReconciliationDebtorAccountsCorrections(
        id: string,
        request: reconciliation_CreateCorrectionRequest,
    ): CancelablePromise<reconciliation_CorrectionDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/debtor-accounts/{id}/corrections',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Invalid ID`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Debtor account not found`,
                422: `Invalid correction input`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Update a debtor's dunning exclusion flag
     * Sets the dunning_excluded flag (boolean) and an optional free-text reason. When excluded=true and the previous state was false, any active dunning workflow for the debtor is auto-cancelled with the reason recorded as audit comment. When excluded=false the reason column is cleared regardless of any reason supplied in the body.
     * @param id Debtor account ID
     * @param body Exclusion flag + optional reason
     * @returns reconciliation_DebtorAccountDTO Updated debtor account
     * @throws ApiError
     */
    public static patchApiV1ReconciliationDebtorAccountsDunningExclusion(
        id: string,
        body: reconciliation_UpdateDunningExclusionRequest,
    ): CancelablePromise<reconciliation_DebtorAccountDTO> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/reconciliation/debtor-accounts/{id}/dunning-exclusion',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Invalid input`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Debtor account not found`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Get a debtor's known payer IBANs
     * Returns the union of contract-payer IBANs and active iban-type matching rules for the debtor. Loaded lazily when the IBANs tab is opened.
     * @param id Debtor account ID
     * @returns reconciliation_DebtorIbansResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationDebtorAccountsIbans(
        id: string,
    ): CancelablePromise<reconciliation_DebtorIbansResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/debtor-accounts/{id}/ibans',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid ID`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * List invoice-level corrections for a debtor account
     * Returns all invoice-level corrections (rows in invoice_overrides) for the given debtor account, ordered newest first. Parent debtors see scope='parent' overrides; subsidy-office debtors see scope='subsidy_office' overrides.
     * @param id Debtor account ID
     * @returns reconciliation_InvoiceCorrectionListResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationDebtorAccountsInvoiceCorrections(
        id: string,
    ): CancelablePromise<reconciliation_InvoiceCorrectionListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/debtor-accounts/{id}/invoice-corrections',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid ID`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Debtor account not found`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Get invoice coverage grid for a debtor's children
     * Returns a per-child, per-month coverage grid classifying each month in the requested window as one of: "paid_on_time", "paid_late", "partial", "unpaid" (covering invoice exists), "missing" (billable but no covering invoice), or "no_services". Subsidy-office debtors always return children:[]. Both query params are optional: default to=current month, from=to−11 months (trailing 12).
     * @param id Debtor account ID
     * @param from Start month (YYYY-MM, default to−11 months)
     * @param to End month (YYYY-MM, default current month)
     * @returns reconciliation_DebtorInvoiceCoverageResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationDebtorAccountsInvoiceCoverage(
        id: string,
        from?: string,
        to?: string,
    ): CancelablePromise<reconciliation_DebtorInvoiceCoverageResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/debtor-accounts/{id}/invoice-coverage',
            path: {
                'id': id,
            },
            query: {
                'from': from,
                'to': to,
            },
            errors: {
                400: `Invalid ID or date params`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Get a debtor's ledger page
     * Returns one newest-first page of the debtor's merged event feed (invoices finalized, payments received, applications, debtor-credit consumptions, account corrections and their reversals). Paginated because a long-lived debtor's full-lifetime ledger can run to thousands of rows. Pass `all=1` to fetch the whole ledger in a single execution (limit defaults to and caps at 20000) — used by the analytics detail view so the 8-stream UNION runs ONCE instead of once per parallel page.
     * @param id Debtor account ID
     * @param limit Page size (default 50, max 200; when all=1 default 20000, max 20000)
     * @param offset Row offset (default 0)
     * @param all Fetch the whole ledger in one execution (raises the limit ceiling to 20000)
     * @returns reconciliation_DebtorLedgerResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationDebtorAccountsLedger(
        id: string,
        limit?: number,
        offset?: number,
        all?: boolean,
    ): CancelablePromise<reconciliation_DebtorLedgerResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/debtor-accounts/{id}/ledger',
            path: {
                'id': id,
            },
            query: {
                'limit': limit,
                'offset': offset,
                'all': all,
            },
            errors: {
                400: `Invalid ID or paging params`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Generate the missing invoices for a debtor account
     * Resolves the billable child-months without a covering invoice for the debtor account within [from, to], groups them by period and generates the missing invoices (one generation pass per period). With finalize=true each freshly created draft with a positive total is also finalized (the missing indicator only clears once invoices are finalized; drafts alone do not cover a month). Both bounds are inclusive month starts (YYYY-MM-01). Staff only; mutation rate-limited.
     * @param id Debtor account ID
     * @param request Window + finalize flag
     * @returns reconciliation_GenerateMissingInvoicesResponse OK
     * @throws ApiError
     */
    public static postApiV1ReconciliationDebtorAccountsMissingInvoicesGenerate(
        id: string,
        request: reconciliation_GenerateMissingInvoicesRequest,
    ): CancelablePromise<reconciliation_GenerateMissingInvoicesResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/debtor-accounts/{id}/missing-invoices/generate',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Invalid ID, body, or window`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Get a debtor's cash-in register page
     * Returns one newest-first page of every inbound payment for the debtor (parent OR subsidy office) with its disposition (applied invoices / on-account credit), best-effort child attribution via bank remittance, and the received/applied/credit totals footer. Read-only; the per-debtor variant omits the Debtor columns.
     * @param id Debtor account ID
     * @param limit Page size (default 50, max 200)
     * @param offset Row offset (default 0)
     * @returns reconciliation_DebtorPaymentRegisterResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationDebtorAccountsPayments(
        id: string,
        limit?: number,
        offset?: number,
    ): CancelablePromise<reconciliation_DebtorPaymentRegisterResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/debtor-accounts/{id}/payments',
            path: {
                'id': id,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Invalid ID or paging params`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Get a debtor's period reconciliation
     * Opening balance, invoiced, paid, credited and closing balance of one debtor account for the months from..to (inclusive), for reconciling against a spreadsheet (#1989). Balances are what the debtor owes (negative = credit). Invoices are the debtor's split amounts dated by the day they were finalized (a draft by its invoice date); payments by received date; refunds by their application date and netted into paid; account corrections at creation, a reverted correction booking its inverse at reversal. A range ending today closes on the detail endpoint's balance (the negated net balance).
     * @param id Debtor account ID
     * @param from First month YYYY-MM
     * @param to Last month YYYY-MM (at most 120 months after from, inclusive)
     * @returns reconciliation_DebtorPeriodSummaryResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationDebtorAccountsPeriodSummary(
        id: string,
        from: string,
        to: string,
    ): CancelablePromise<reconciliation_DebtorPeriodSummaryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/debtor-accounts/{id}/period-summary',
            path: {
                'id': id,
            },
            query: {
                'from': from,
                'to': to,
            },
            errors: {
                400: `Invalid ID or month range`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Debtor account not found`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Subsidy office unapplied-credit breakdown (per child / month)
     * Lists the over-paid inbound payments that compose a subsidy office's unapplied credit pool, attributed to a child via the bank remittance reference and the month they were received. Answers "which child / which month did the office overpay". Filtered by received_date period + optional child search; sorted via sort. Footer carries the filtered subset total and the whole credit pool.
     * @param id Debtor account id (must be a subsidy office)
     * @param periodStart Period start (YYYY-MM-DD; defaults to today - 12 months)
     * @param periodEnd Period end (YYYY-MM-DD; defaults to today)
     * @param q Child search: internal id / first / last / full name / remittance
     * @param sort Sort: unapplied_desc (default) | unapplied_asc | received_desc | received_asc | child_asc
     * @param limit Page size (default 100, max 500)
     * @param offset Page offset (default 0)
     * @returns reconciliation_SubsidyUnappliedCreditResponseDTO OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationDebtorAccountsSubsidyCredit(
        id: string,
        periodStart?: string,
        periodEnd?: string,
        q?: string,
        sort?: 'unapplied_desc' | 'unapplied_asc' | 'received_desc' | 'received_asc' | 'child_asc',
        limit?: number,
        offset?: number,
    ): CancelablePromise<reconciliation_SubsidyUnappliedCreditResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/debtor-accounts/{id}/subsidy-credit',
            path: {
                'id': id,
            },
            query: {
                'period_start': periodStart,
                'period_end': periodEnd,
                'q': q,
                'sort': sort,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }
    /**
     * Subsidy ledger view for a debtor account
     * Returns per-child subsidy obligations vs receipts for the given debtor in the requested period (defaults to the last 12 months). Aggregate totals included in the response.
     * @param id Debtor account id
     * @param periodStart Period start (YYYY-MM-DD; defaults to today - 12 months)
     * @param periodEnd Period end (YYYY-MM-DD; defaults to today)
     * @param status Triage filter: all | outstanding | paid (default all)
     * @param q Child search: internal id / first / last / full name
     * @param sort Sort: <col>_<dir> over child|child_id|period|expected|paid|outstanding (default period_desc)
     * @param limit Page size (default 100, max 500)
     * @param offset Page offset (default 0)
     * @returns reconciliation_SubsidyLedgerResponseDTO OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationDebtorAccountsSubsidyLedger(
        id: string,
        periodStart?: string,
        periodEnd?: string,
        status?: 'all' | 'outstanding' | 'paid',
        q?: string,
        sort?: 'period_desc' | 'period_asc' | 'child_asc' | 'child_desc' | 'child_id_asc' | 'child_id_desc' | 'expected_asc' | 'expected_desc' | 'paid_asc' | 'paid_desc' | 'outstanding_asc' | 'outstanding_desc',
        limit?: number,
        offset?: number,
    ): CancelablePromise<reconciliation_SubsidyLedgerResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/debtor-accounts/{id}/subsidy-ledger',
            path: {
                'id': id,
            },
            query: {
                'period_start': periodStart,
                'period_end': periodEnd,
                'status': status,
                'q': q,
                'sort': sort,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }
    /**
     * Per-child aggregated subsidy totals for a debtor account
     * Returns one row per child with summed expected/paid/outstanding. Period is optional (omit for all time). Status: all | outstanding (net>0) | overpaid (net<0).
     * @param id Debtor account id
     * @param periodStart Period start (YYYY-MM-DD; omit for all time)
     * @param periodEnd Period end (YYYY-MM-DD; omit for all time)
     * @param status Status filter: all | outstanding | overpaid (default all)
     * @param q Child search: internal id / first / last / full name
     * @param sort Sort key (default child_id_asc)
     * @param match Expected-vs-Cash-in lens: all (default) or unmatched (Expected differs from Cash-in on the 5-Rappen grid)
     * @returns reconciliation_SubsidyChildTotalsResponseDTO OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationDebtorAccountsSubsidyLedgerChildTotals(
        id: string,
        periodStart?: string,
        periodEnd?: string,
        status?: 'all' | 'outstanding' | 'overpaid',
        q?: string,
        sort?: 'child_id_asc' | 'child_id_desc' | 'child_asc' | 'child_desc' | 'expected_asc' | 'expected_desc' | 'paid_asc' | 'paid_desc' | 'outstanding_asc' | 'outstanding_desc',
        match?: 'all' | 'unmatched',
    ): CancelablePromise<reconciliation_SubsidyChildTotalsResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/debtor-accounts/{id}/subsidy-ledger/child-totals',
            path: {
                'id': id,
            },
            query: {
                'period_start': periodStart,
                'period_end': periodEnd,
                'status': status,
                'q': q,
                'sort': sort,
                'match': match,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }
    /**
     * Subsidy ledger per-month rollup for a debtor account
     * Returns one aggregated row per calendar month (distinct children + summed expected/paid/outstanding + latest payment date) for the given subsidy debtor over the requested period (defaults to the last 12 months). Not paginated — always covers the full period.
     * @param id Debtor account id
     * @param periodStart Period start (YYYY-MM-DD; defaults to today - 12 months)
     * @param periodEnd Period end (YYYY-MM-DD; defaults to today)
     * @returns reconciliation_SubsidyLedgerMonthlyResponseDTO OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationDebtorAccountsSubsidyLedgerMonthly(
        id: string,
        periodStart?: string,
        periodEnd?: string,
    ): CancelablePromise<reconciliation_SubsidyLedgerMonthlyResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/debtor-accounts/{id}/subsidy-ledger/monthly',
            path: {
                'id': id,
            },
            query: {
                'period_start': periodStart,
                'period_end': periodEnd,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }
    /**
     * Per-debtor monetary aggregates
     * Returns the monetary aggregates (open invoice count, total outstanding / received / invoiced, net balance, last payment date) for the given list of debtor IDs. Used as the hydration step after the cheap ListDebtorAccounts list query lands so the FE can render names immediately and fill the money cells when the aggregates resolve. IDs are passed as a comma-separated `ids` query parameter; unknown / cross-tenant / soft-deleted IDs are silently dropped.
     * @param ids Comma-separated list of debtor IDs (max 100)
     * @returns reconciliation_DebtorAccountAggregatesResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationDebtorAccountsAggregates(
        ids: string,
    ): CancelablePromise<reconciliation_DebtorAccountAggregatesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/debtor-accounts/aggregates',
            query: {
                'ids': ids,
            },
            errors: {
                400: `Missing or oversized ids parameter`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Get a child's parent debtor account
     * Resolves the PARENT debtor account (subsidy offices excluded) for a child via contracts → contract_payers → debtor_accounts, returning its id + display name so the child page can link to the debtor account. Returns 404 when the child has no parent debtor account.
     * @param childId Child ID
     * @returns reconciliation_DebtorAccountByChildResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationDebtorAccountsByChild(
        childId: string,
    ): CancelablePromise<reconciliation_DebtorAccountByChildResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/debtor-accounts/by-child/{childId}',
            path: {
                'childId': childId,
            },
            errors: {
                400: `Invalid child ID`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `No parent debtor account for this child`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Per-debtor unapplied-credit batch (lite)
     * Returns just the unapplied-credit balance + display name for the given list of debtor IDs. Powers the invoice-card credit pill: the Invoices tab batches every visible card's payer debtor IDs into ONE call instead of firing the heavy debtor-detail endpoint (6 correlated LATERALs over the debtor's whole history) per card just to usually render nothing. A plain column read. IDs are passed as a comma-separated `ids` query parameter (max 200); unknown / cross-tenant / soft-deleted IDs are silently dropped.
     * @param ids Comma-separated list of debtor IDs (max 200)
     * @returns reconciliation_DebtorCreditBatchResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationDebtorAccountsCreditBatch(
        ids: string,
    ): CancelablePromise<reconciliation_DebtorCreditBatchResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/debtor-accounts/credit-batch',
            query: {
                'ids': ids,
            },
            errors: {
                400: `Missing or oversized ids parameter`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Per-debtor trailing-12-month billed-vs-collected series
     * Returns, per requested debtor ID, the trailing 12 calendar months (current month + the preceding 11) of {month, billedCents, collectedCents}. Powers the per-row 12-month heatmap / sparkline on the reconciliation overview so the table never pulls a full per-debtor ledger. billed mirrors the aggregates split attribution (debtor's share of finalized invoices, by finalized month); collected mirrors the ledger payment_received stream (payments by debtor_account_id + received month) — so the figures reconcile with the ledger / aggregates. Only months with non-zero activity are returned (the FE gap-fills); IDs with no activity, and unknown / cross-tenant / soft-deleted IDs, are silently dropped. IDs are passed as a comma-separated `ids` query parameter (max 100).
     * @param ids Comma-separated list of debtor IDs (max 100)
     * @returns reconciliation_DebtorMonthlySeriesResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationDebtorAccountsMonthlySeries(
        ids: string,
    ): CancelablePromise<reconciliation_DebtorMonthlySeriesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/debtor-accounts/monthly-series',
            query: {
                'ids': ids,
            },
            errors: {
                400: `Missing or oversized ids parameter`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Org-wide debtor-accounts summary
     * Returns the rolled-up Total outstanding, Unapplied credit, Net balance, and debtor count across every non-deleted debtor account in the caller's org. Powers the summary-cards strip at the top of the Debtor Accounts page. Aggregates ignore any filter/search the operator has applied on the list view — these are always the org total.
     * @returns reconciliation_DebtorAccountsSummaryResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationDebtorAccountsSummary(): CancelablePromise<reconciliation_DebtorAccountsSummaryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/debtor-accounts/summary',
            errors: {
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Apply the flatten-departed settlement
     * Settles every eligible departed parent debtor to a net balance of zero, grouped under one settlement batch. Re-previews from scratch for authoritative eligibility; skips any debtor no longer eligible at the in-tx re-check.
     * @param request Settlement parameters
     * @returns reconciliation_FlattenBatchResultResponse OK
     * @throws ApiError
     */
    public static postApiV1ReconciliationFlattenDepartedApply(
        request: reconciliation_FlattenApplyRequest,
    ): CancelablePromise<reconciliation_FlattenBatchResultResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/flatten-departed/apply',
            body: request,
            errors: {
                400: `Invalid input`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Revert a single family's settlement within a batch
     * Atomically backs out all corrections and write-off drains for one debtor in the given batch. Idempotent: calling it again after a full revert is a no-op.
     * @param batchId Settlement batch ID
     * @param debtorId Debtor account ID
     * @param request Optional revert reason
     * @returns void
     * @throws ApiError
     */
    public static postApiV1ReconciliationFlattenDepartedBatchesFamiliesRevert(
        batchId: string,
        debtorId: string,
        request?: reconciliation_FlattenRevertRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/flatten-departed/batches/{batchId}/families/{debtorId}/revert',
            path: {
                'batchId': batchId,
                'debtorId': debtorId,
            },
            body: request,
            errors: {
                400: `Invalid input`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Revert an entire flatten-departed settlement batch
     * Reverts every family settled under the given batch, family-by-family. Idempotent: already-reverted families are skipped. Returns the count of families that still had something to revert.
     * @param batchId Settlement batch ID
     * @param request Optional revert reason
     * @returns reconciliation_RevertBatchResponse OK
     * @throws ApiError
     */
    public static postApiV1ReconciliationFlattenDepartedBatchesRevert(
        batchId: string,
        request?: reconciliation_FlattenRevertRequest,
    ): CancelablePromise<reconciliation_RevertBatchResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/flatten-departed/batches/{batchId}/revert',
            path: {
                'batchId': batchId,
            },
            body: request,
            errors: {
                400: `Invalid input`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Preview the flatten-departed settlement plan
     * Returns the classified list of departed parent debtor accounts: those eligible for auto-settlement (under the threshold) and those excluded. Read-only; makes no DB writes.
     * @param threshold Maximum absolute net balance in cents to include in settlement (must be > 0)
     * @param leftBefore Only families whose children all left before this date (YYYY-MM-DD)
     * @returns reconciliation_FlattenPlanResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationFlattenDepartedPreview(
        threshold: number,
        leftBefore: string,
    ): CancelablePromise<reconciliation_FlattenPlanResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/flatten-departed/preview',
            query: {
                'threshold': threshold,
                'leftBefore': leftBefore,
            },
            errors: {
                400: `Missing or invalid query parameters`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * List import batches
     * Paginated list of bank-statement imports for the organization, newest-first.
     * @param limit Page size (1-100, default 20)
     * @param offset Skip count (default 0)
     * @returns reconciliation_ImportBatchListResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationImports(
        limit?: number,
        offset?: number,
    ): CancelablePromise<reconciliation_ImportBatchListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/imports',
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Invalid pagination parameter`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Upload a bank-statement CSV for reconciliation
     * Multipart file upload. Parses UBS CSV, persists batch + transactions + payments, runs the matcher + applier synchronously. Returns the batch summary.
     * @param file UBS CSV export (max 5 MB)
     * @returns reconciliation_ImportBatchResponse Created
     * @throws ApiError
     */
    public static postApiV1ReconciliationImports(
        file: Blob,
    ): CancelablePromise<reconciliation_ImportBatchResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/imports',
            formData: {
                'file': file,
            },
            errors: {
                400: `Missing or malformed file`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                413: `File exceeds 5 MB`,
                422: `Parser error or invalid magic bytes`,
                429: `Rate limit exceeded`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Get import batch detail
     * Returns one batch plus its imported bank transactions.
     * @param id Import batch ID
     * @returns reconciliation_ImportBatchDetailResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationImports1(
        id: string,
    ): CancelablePromise<reconciliation_ImportBatchDetailResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/imports/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid ID`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Import batch not found`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Revert an import batch
     * Soft-deletes payments + transactions, reverses applications, debits debtor credit, and transitions the batch to "reverted".
     * @param id Import batch ID
     * @returns string OK
     * @throws ApiError
     */
    public static postApiV1ReconciliationImportsRevert(
        id: string,
    ): CancelablePromise<Record<string, string>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/imports/{id}/revert',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid ID`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Import batch not found`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * List payment applications touching an invoice
     * Returns the non-deleted payment_applications that touch any split of the given invoice, newest first. Powers the InvoicesPage "View payments" side-sheet. Each row carries payerKind (parent|subsidy), the paying debtorAccountId, and its debtorDisplayName so the sheet can say who paid and link to that account.
     * @param invoiceId Invoice ID
     * @param limit Page size (1-100, default 20)
     * @param offset Skip count (default 0)
     * @returns reconciliation_ApplicationListResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationInvoicesPaymentApplications(
        invoiceId: string,
        limit?: number,
        offset?: number,
    ): CancelablePromise<reconciliation_ApplicationListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/invoices/{invoiceId}/payment-applications',
            path: {
                'invoiceId': invoiceId,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Invalid input`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Invoice not found`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Get reconciliation metrics for the caller's org
     * Returns the three reconciliation aggregates (review-queue size, debtor credit total in cents, 30-day auto-match rate) for the authenticated caller's org. Replaces the org-scoped breakdown that used to live on the public /metrics endpoint. See docs/guides/payment-reconciliation.md §12.2.1.
     * @returns reconciliation_ReconciliationMetricsResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationMetrics(): CancelablePromise<reconciliation_ReconciliationMetricsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/metrics',
            errors: {
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Org-wide missing invoices grouped by family
     * Returns the list of families that have at least one missing invoice in the requested window, sorted by missingCount desc. Without `year` the window is the trailing 12 calendar months ("running year"); with a numeric `year` it is that calendar year (Jan–Dec, capped at the current month for the current year); with `year=all` it spans the org's earliest billed year through the current month. An out-of-range numeric `year` is clamped to [minYear, maxYear]. Families are capped at 50; totalFamilies / totalMissing reflect pre-cap counts. Parent/household + contact debtors only — subsidy-office debtors have no children and are never flagged missing.
     * @param year Calendar year to check, or \
     * @returns reconciliation_MissingInvoicesResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationMissingInvoices(
        year?: string,
    ): CancelablePromise<reconciliation_MissingInvoicesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/missing-invoices',
            query: {
                'year': year,
            },
            errors: {
                400: `Invalid year parameter`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Org-wide billed / collected / outstanding monthly trend
     * Returns the org-wide {month, billedCents, collectedCents, outstandingCents} series for the reconciliation overview's billed-vs-collected card and the finance metrics, plus minYear/maxYear for the year picker. Each measure also carries its parent (Elternbeitrag) and subsidy-office (Subventionsbetrag) legs — billed{Parent,Subsidy}Cents, collected{Parent,Subsidy}Cents, outstanding{Parent,Subsidy}Cents — so the FE stacks the parent/subsidy segments and draws the two outstanding lines; each total equals its parent + subsidy leg. Window: `from` and `to` (months, YYYY-MM, both or neither) win over `year`; `year` is that calendar year; neither is the trailing 12 calendar months ("running year"). Every window is capped at the current month. `compare_to=previous_year` starts the window 12 months earlier, so a chart and its year-ago months are one request; a window holds at most 600 months. billed = SUM of finalized invoice splits by finalized month (the full billing basis, so the total includes the subsidy receivable); collected = SUM of payments by received month (subsidy leg = payments to a subsidy-office debtor); outstanding = the TRUE month-end receivable (per-split floored billed − cash applied by that month — a point-in-time balance, not a cumulative). Read from the receivable_months aggregate (#2192). The series is DENSE (every window month). Org-scoped. An out-of-range `year` is clamped to [minYear, maxYear].
     * @param year Calendar year to chart (omit for the trailing-12-month running year)
     * @param from First month of the window, YYYY-MM (with to; wins over year)
     * @param to Last month of the window, YYYY-MM (with from; capped at the current month)
     * @param compareTo previous_year: start the window 12 months earlier
     * @returns reconciliation_OrgMonthlyTrendResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationMonthlyTrend(
        year?: number,
        from?: string,
        to?: string,
        compareTo?: 'previous_year',
    ): CancelablePromise<reconciliation_OrgMonthlyTrendResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/monthly-trend',
            query: {
                'year': year,
                'from': from,
                'to': to,
                'compare_to': compareTo,
            },
            errors: {
                400: `Invalid year, from/to or compare_to parameter`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Undo an office reclaim netting
     * Administrator role required. Undoes an office reclaim netting pair from either of its rows (office_reclaim_out or office_reclaim_in) in one transaction: both rows are soft-deleted with the reason, both open amounts and the target's netted-in ceiling are restored. Refused with 409 RECLAIM_NETTING_CONSUMED while the target payment has already allocated the netted money, and with 409 RECLAIM_NETTING_ALREADY_REVERTED when a concurrent undo won. Any other application is 400 APPLICATION_NOT_MANUAL.
     * @param applicationId Either row of the netting pair
     * @param body Undo reason
     * @returns reconciliation_OfficeReclaimRevertResponse OK
     * @throws ApiError
     */
    public static postApiV1ReconciliationOfficeReclaimsRevert(
        applicationId: string,
        body: reconciliation_RevertApplicationRequest,
    ): CancelablePromise<reconciliation_OfficeReclaimRevertResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/office-reclaims/{applicationId}/revert',
            path: {
                'applicationId': applicationId,
            },
            body: body,
            errors: {
                400: `Invalid identifier, or not a reclaim netting row`,
                401: `Authentication required`,
                403: `Caller is not an administrator, or organization ID not found in token`,
                404: `Payment application not found`,
                409: `Netted money consumed, or already reverted`,
                422: `Validation failed`,
                429: `Rate limit exceeded`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Undo a single payment application (surgical unwind)
     * Reverses one payment_applications row from the debtor ledger. Works on operator-driven rows only (manual, manual_credit_to_debtor, manual_credit_apply). Refuses with HTTP 409 + FIFODriftResponse when downstream rows have consumed credit.
     * @param id Payment application ID
     * @param body Operator-supplied revert reason
     * @returns reconciliation_RevertResponse OK
     * @throws ApiError
     */
    public static postApiV1ReconciliationPaymentApplicationsRevert(
        id: string,
        body: reconciliation_RevertApplicationRequest,
    ): CancelablePromise<reconciliation_RevertResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/payment-applications/{id}/revert',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Invalid ID or non-manual application`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Payment application not found`,
                409: `FIFO drift, consuming applications listed`,
                422: `Validation failed (missing, too short, or too long reason)`,
                429: `Rate limit exceeded`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * List payments
     * Paginated list of payments for the organization. Supports status, date-range, and debtor filters.
     * @param status Filter by payment status
     * @param receivedFrom Inclusive lower bound (YYYY-MM-DD)
     * @param receivedTo Inclusive upper bound (YYYY-MM-DD)
     * @param debtorId Filter by debtor account ID
     * @param limit Page size (1-100, default 20)
     * @param offset Skip count (default 0)
     * @returns reconciliation_PaymentListResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationPayments(
        status?: 'unapplied' | 'partially_applied' | 'applied',
        receivedFrom?: string,
        receivedTo?: string,
        debtorId?: string,
        limit?: number,
        offset?: number,
    ): CancelablePromise<reconciliation_PaymentListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/payments',
            query: {
                'status': status,
                'received_from': receivedFrom,
                'received_to': receivedTo,
                'debtor_id': debtorId,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Invalid query parameter`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Add a manual cash-in, or a refund when the amount is negative
     * A positive amountCents records a single admin-entered payment (cash/cheque) as a synthetic manual bank transaction (no CSV import batch) plus an unapplied payment parked on-account, and returns 201 with the payment. A negative amountCents records a refund — money paid back out to the family or subsidy office — which draws down that account's unapplied credit instead of creating a payment, and returns 200 with a refund summary. A refund requires debtorAccountId and may not exceed the account's available credit (409). Staff-only. Never mutates a CSV import batch's counts.
     * @param request Manual payment details; negative amountCents means a refund
     * @returns reconciliation_ManualRefundResponse Refund recorded (negative amountCents)
     * @returns reconciliation_PaymentDTO Cash-in recorded
     * @throws ApiError
     */
    public static postApiV1ReconciliationPayments(
        request: reconciliation_CreateManualPaymentRequest,
    ): CancelablePromise<reconciliation_ManualRefundResponse | reconciliation_PaymentDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/payments',
            body: request,
            errors: {
                400: `Invalid input`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                409: `Refund exceeds the account's available credit`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Get payment detail
     * Returns one payment plus its applied splits.
     * @param id Payment ID
     * @returns reconciliation_PaymentDetailResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationPayments1(
        id: string,
    ): CancelablePromise<reconciliation_PaymentDetailResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/payments/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid ID`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Payment not found`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Apply a payment to one or more invoice splits
     * Manually applies the payment's credit to the specified splits via the reconciliation applier.
     * @param id Payment ID
     * @param request Apply request
     * @returns string OK
     * @throws ApiError
     */
    public static postApiV1ReconciliationPaymentsApply(
        id: string,
        request: reconciliation_ApplyPaymentRequest,
    ): CancelablePromise<Record<string, string>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/payments/{id}/apply',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Invalid input`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Payment not found`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Manually flag a payment as a subsidy office payment
     * Routes a payment off the parent review queue onto the subsidy matching tab by attributing it to a subsidy office's debtor account.
     * @param id Payment ID
     * @param body Subsidy office to attribute the payment to
     * @returns reconciliation_MarkAsSubsidyResponse OK
     * @throws ApiError
     */
    public static postApiV1ReconciliationPaymentsMarkAsSubsidy(
        id: string,
        body: reconciliation_MarkAsSubsidyRequest,
    ): CancelablePromise<reconciliation_MarkAsSubsidyResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/payments/{id}/mark-as-subsidy',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                412: `Precondition Failed`,
            },
        });
    }
    /**
     * List the matching rules that fire for a payment
     * Returns the ACTIVE matching rules whose match_value matches this payment's signals (counterparty IBAN, normalised counterparty name, QR reference). Backs the Credited recap's "a rule was learned from this — delete it?" affordance. Note these are org-scoped rules, not payment-scoped: a returned rule may predate this payment, and deleting it (DELETE /rules/{id}) affects every future payment carrying that signal.
     * @param id Payment ID
     * @returns reconciliation_PaymentMatchingRulesResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationPaymentsMatchingRules(
        id: string,
    ): CancelablePromise<reconciliation_PaymentMatchingRulesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/payments/{id}/matching-rules',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid ID`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Payment not found`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Release an applied payment back to on-account credit
     * Detaches an applied payment (full when amountCents is omitted, otherwise the partial amount) from its invoice splits back to the debtor's on-account credit, recomputing the affected invoices' derived paid-status. The freed credit can then be re-allocated via the apply-credit flow.
     * @param id Payment ID
     * @param request Release amount (optional) and note
     * @returns reconciliation_ReleasePaymentResponse OK
     * @throws ApiError
     */
    public static postApiV1ReconciliationPaymentsRelease(
        id: string,
        request: reconciliation_ReleasePaymentRequest,
    ): CancelablePromise<reconciliation_ReleasePaymentResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/payments/{id}/release',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Invalid input`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Payment not found`,
                422: `Release amount exceeds applied, or the payment belongs to a subsidy office whose money cannot be parked as account credit`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Global cash-in register
     * Org-wide, searchable, filterable register of money in AND money back out (issue #761 Phase 1b; refunds added by issue #1300). A row is either kind=payment (an inbound payment, positive) or kind=refund (a credit draw-down paid back out, NEGATIVE amountCents, id = the payment_applications id that POST /reconciliation/refunds/{id}/revert takes). THE REFUND ARM IS OPT-IN: kind absent returns payments only (the pre-#1300 response), kind=all returns both. That default exists so a client cannot list refund rows under a footer that does not count them. Payment rows carry their disposition (applied invoices / on-account credit) and best-effort child attribution via bank remittance; refund rows carry neither. Filters: kind, status, debtor type (parent|office), date range, import batch, and a free-text search. The status and import_batch_id filters are payment-only — a refund has neither — so setting either excludes refunds. Read-only, staff-only.
     * @param kind Register arm(s). Absent means payments only — the refund arm is opt-in
     * @param status Filter by payment status (payment rows only)
     * @param debtorType Filter by debtor type
     * @param from Inclusive received-date lower bound (YYYY-MM-DD)
     * @param to Inclusive received-date upper bound (YYYY-MM-DD)
     * @param importBatchId Filter to one CSV import batch
     * @param search Free-text: counterparty / remittance / child id+name / amount (max 255)
     * @param limit Page size (1-200, default 50)
     * @param offset Skip count (default 0)
     * @returns reconciliation_PaymentRegisterResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationPaymentsRegister(
        kind?: 'payment' | 'refund' | 'all',
        status?: 'unapplied' | 'partially_applied' | 'applied',
        debtorType?: 'parent' | 'office',
        from?: string,
        to?: string,
        importBatchId?: string,
        search?: string,
        limit?: number,
        offset?: number,
    ): CancelablePromise<reconciliation_PaymentRegisterResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/payments/register',
            query: {
                'kind': kind,
                'status': status,
                'debtor_type': debtorType,
                'from': from,
                'to': to,
                'import_batch_id': importBatchId,
                'search': search,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Invalid query parameter`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Undo a refund (return the money to the account's credit)
     * Reverses one 'manual_refund' payment_applications row: the refunded amount returns to the debtor's unapplied credit and to the source payment it was drawn from. Separate from /payment-applications/{id}/revert because the generic per-application path resets a payment's match attribution once it has no live applications left, which would detach the payment from the debtor whose credit was just restored and leave credit with no backing payment. That endpoint therefore refuses refund rows with APPLICATION_NOT_MANUAL and directs the operator here.
     * @param id Payment application ID of the refund row
     * @param body Operator-supplied revert reason
     * @returns reconciliation_RevertResponse OK
     * @throws ApiError
     */
    public static postApiV1ReconciliationRefundsRevert(
        id: string,
        body: reconciliation_RevertApplicationRequest,
    ): CancelablePromise<reconciliation_RevertResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/refunds/{id}/revert',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Invalid ID, or the application is not a refund`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Payment application not found`,
                422: `Validation failed (missing, too short, or too long reason)`,
                429: `Rate limit exceeded`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * List unapplied payments awaiting review
     * Paginated list of payments with status=unapplied, ordered by received_date DESC. Each row is enriched with the parent bank_transaction's counterparty name / IBAN / remittance info so the Review Queue UI renders without a second round-trip per row. When status=ignored is passed, the response shape switches to the ignored bank_transactions list (Restore view). When status=credited is passed, the response shape switches to the Credited view (bank_transactions in status='matched', ordered by the most recent matched_at across the row's payments, defaulting to the last 30 days unless a search term widens the window). The optional `search` query param narrows results by amount, QR-Reference or remittance info; it applies to all three views.
     * @param status Set to 'ignored' for the Restore view, 'credited' for the recently confirmed view, 'duplicates' for live import rows that share QR reference, amount and booking day with another row (credited shape); defaults to 'active'. Any other value is rejected with 400.
     * @param search Optional case-insensitive substring filter applied to amount (formatted display value), QR-Reference and remittance info ('Payment reference').
     * @param limit Page size (1-100, default 20)
     * @param offset Skip count (default 0)
     * @returns reconciliation_CreditedReviewQueueListResponse Credited queue response (status=credited)
     * @throws ApiError
     */
    public static getApiV1ReconciliationReviewQueue(
        status?: 'active' | 'ignored' | 'credited' | 'duplicates',
        search?: string,
        limit?: number,
        offset?: number,
    ): CancelablePromise<reconciliation_CreditedReviewQueueListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/review-queue',
            query: {
                'status': status,
                'search': search,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Invalid pagination or status parameter`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * List ranked candidates for a review-queue payment
     * Returns up to 10 candidate invoice splits ranked by the matcher cascade (rows #1-#7) scoped to a single payment. Ordered by confidence desc, due_date asc, split id asc.
     * @param id Payment ID
     * @returns reconciliation_CandidateListResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationReviewQueueCandidates(
        id: string,
    ): CancelablePromise<reconciliation_CandidateListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/review-queue/{id}/candidates',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid ID`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Payment not found`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Confirm a review-queue item
     * Applies the owner's selection in a single atomic transaction: applies each ticked split to its invoice, optionally credits any remainder to the debtor's unapplied_credit balance (so the existing FIFO consumer settles it on the next finalize), and (when requested) writes a counterparty matching_rule. Empty applications + creditRemainderToDebtor=true is the unified Credit-to-debtor path; mixed apply + remainder is the new capability that fixes the previous asymmetry.
     * @param id Payment ID
     * @param request Confirmation payload
     * @returns string OK
     * @throws ApiError
     */
    public static postApiV1ReconciliationReviewQueueConfirm(
        id: string,
        request: reconciliation_ConfirmReviewItemRequest,
    ): CancelablePromise<Record<string, string>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/review-queue/{id}/confirm',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Invalid input`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Payment not found`,
                409: `Payment already applied`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Ignore a review-queue transaction
     * Permanently ignores a bank transaction so the matcher stops re-evaluating it and the active queue hides it. The reason is optional free text (max 500 chars). Idempotent on repeat calls; refuses to flip terminal-applied transactions (status=applied / partially_applied) so an accidental keystroke can never destroy a successful allocation.
     * @param id Bank Transaction ID
     * @param request Ignore payload (reason is optional)
     * @returns void
     * @throws ApiError
     */
    public static postApiV1ReconciliationReviewQueueIgnore(
        id: string,
        request: reconciliation_IgnoreReviewItemRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/review-queue/{id}/ignore',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Invalid input`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Transaction not found`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Undo a confirmed bank transaction (full unwind)
     * Reverses every operator-driven payment_applications row attached to the bank transaction's payment(s), restores invoice splits + debtor credit, resets the payment to unapplied, and flips the bank transaction back to unmatched. Refuses with HTTP 409 + FIFODriftResponse when downstream rows have consumed credit.
     * @param id Bank transaction ID
     * @param body Operator-supplied revert reason
     * @returns reconciliation_RevertResponse OK
     * @throws ApiError
     */
    public static postApiV1ReconciliationReviewQueueRevert(
        id: string,
        body: reconciliation_RevertCreditedRequest,
    ): CancelablePromise<reconciliation_RevertResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/review-queue/{id}/revert',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Invalid ID or non-manual application`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Bank transaction not found`,
                409: `FIFO drift, consuming applications listed`,
                422: `Validation failed (missing, too short, or too long reason)`,
                429: `Rate limit exceeded`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Remove a duplicate-imported bank transaction (full unwind, any match source)
     * Reverts EVERY live payment application of the bank transaction's payment, including auto-match and credit-carry rows, debits the credit the payment still had parked, resets the payment to unapplied and marks the bank transaction ignored with the reason. Every invoice the revert reopened is then re-covered from the debtor's remaining account credit, so the genuine copy of the booking flows onto it. Use it when the same bank booking was imported twice; the response lists what was reopened and what is still open. Refuses subsidy-office payments (409), payments with a live refund or settlement write-off (409) and payments carrying an office reclaim netting (409).
     * @param id Bank transaction ID
     * @param body Operator-supplied reason (stored as the ignore reason)
     * @returns reconciliation_DuplicateRevertResponse OK
     * @throws ApiError
     */
    public static postApiV1ReconciliationReviewQueueRevertDuplicate(
        id: string,
        body: reconciliation_RevertCreditedRequest,
    ): CancelablePromise<reconciliation_DuplicateRevertResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/review-queue/{id}/revert-duplicate',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Invalid ID or the row is not an import row`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Bank transaction or payment not found`,
                409: `Office payment, live refund, or reclaim netting`,
                422: `Validation failed (missing, too short, or too long reason)`,
                429: `Rate limit exceeded`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Restore an ignored review-queue transaction
     * Restores a previously ignored bank transaction back to status='unmatched' so the matcher re-evaluates it on the next run. Clears the audit attribution columns. Returns 404 when the transaction is not currently ignored.
     * @param id Bank Transaction ID
     * @returns void
     * @throws ApiError
     */
    public static postApiV1ReconciliationReviewQueueUnignore(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/review-queue/{id}/unignore',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid input`,
                403: `Organization ID not found in token`,
                404: `Transaction not found or not ignored`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * List matching rules
     * Paginated list of matching rules; supports rule_type and active filters.
     * @param ruleType Filter by rule type
     * @param active Filter by active flag
     * @param limit Page size (1-100, default 20)
     * @param offset Skip count (default 0)
     * @returns reconciliation_MatchingRuleListResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationRules(
        ruleType?: 'iban' | 'counterparty_name' | 'free_text_regex' | 'child_id' | 'child_name' | 'qr_reference',
        active?: boolean,
        limit?: number,
        offset?: number,
    ): CancelablePromise<reconciliation_MatchingRuleListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/rules',
            query: {
                'rule_type': ruleType,
                'active': active,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Invalid query parameter`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Create a matching rule
     * Creates a new matching rule. IBAN rules are normalised (uppercase, whitespace stripped); counterparty-name rules are normalised (trim, collapse whitespace). Returns 409 on duplicate (org_id, rule_type, match_value).
     * @param request Rule payload
     * @returns reconciliation_MatchingRuleDTO Created
     * @throws ApiError
     */
    public static postApiV1ReconciliationRules(
        request: reconciliation_CreateRuleRequest,
    ): CancelablePromise<reconciliation_MatchingRuleDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/rules',
            body: request,
            errors: {
                400: `Invalid input`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Debtor account not found`,
                409: `Rule already exists`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Soft-delete a matching rule
     * Soft-deletes a rule. Already-applied payments that used the rule are unaffected.
     * @param id Rule ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1ReconciliationRules(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/reconciliation/rules/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid ID`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Rule not found`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Update a matching rule
     * Updates match_value / debtor_account_id / active on an existing rule. rule_type is immutable.
     * @param id Rule ID
     * @param request Rule patch
     * @returns reconciliation_MatchingRuleDTO OK
     * @throws ApiError
     */
    public static putApiV1ReconciliationRules(
        id: string,
        request: reconciliation_UpdateRuleRequest,
    ): CancelablePromise<reconciliation_MatchingRuleDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/reconciliation/rules/{id}',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Invalid input`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Rule not found`,
                409: `Duplicate match value or concurrent modification (stale expectedUpdatedAt)`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Unified reconciliation search across debtors, invoices, children, and families
     * Searches across debtor accounts using the supplied query string. Matches invoice number (exact / prefix / substring), child internal id (exact), child first/last name (substring), contact name (substring), and family-group name (substring). Returns one ranked candidate per matching debtor with the same DTO shape as the auto-match candidates endpoint, so the frontend can render results in the same DebtorGroupedCandidateCard component. When the query matches an invoice number, the response pre-selects that invoice's split.
     * @param q Search query — invoice number, child name / internal id, contact name, or family name (min 2, max 200 chars)
     * @param limit Maximum results (1-50, default 20)
     * @returns reconciliation_SearchReconciliationResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationSearch(
        q: string,
        limit?: number,
    ): CancelablePromise<reconciliation_SearchReconciliationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/search',
            query: {
                'q': q,
                'limit': limit,
            },
            errors: {
                400: `Invalid input`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Download link of a finished audit pack (Stichproben pack)
     * Administrator role, billing and children modules required. Returns a presigned link valid 5 minutes to the ZIP of a pack of the caller's organisation. A pack is kept 24 hours.
     * @param packId Pack id from the build's complete event
     * @returns reconciliation_StichprobePackDownloadResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationStichprobePackDownload(
        packId: string,
    ): CancelablePromise<reconciliation_StichprobePackDownloadResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/stichprobe-pack/{packId}/download',
            path: {
                'packId': packId,
            },
            errors: {
                401: `Authentication required`,
                403: `Administrator, billing and children module required`,
                404: `Pack not found or expired`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * List subsidy obligations for a debtor account in a month
     * Returns the subsidy invoice_splits (`split_kind='subsidy'`) owned by the given debtor for the requested invoice month. Caller MUST provide either (`period_year`, `period_month`) or the legacy (`period_start`, `period_end`) pair. When `include_paid=true` (default) already-paid splits are included so the operator sees the full month picture; the FE renders those rows read-only.
     * @param debtorAccountId Subsidy office's debtor account id
     * @param periodYear Invoice month year (e.g. 2026). Required when period_start/period_end are not supplied.
     * @param periodMonth Invoice month (1-12). Required when period_start/period_end are not supplied.
     * @param includePaid Include already-paid splits in the response (default true)
     * @param status Triage filter over the derived balance. Narrows items only; monthTotals always describes the whole month.
     * @param childInternalId Narrow the month to a single child by internal id. Narrows items only; monthTotals always describes the whole month.
     * @param periodStart (Deprecated) Period start YYYY-MM-DD; fallback when period_year/period_month absent
     * @param periodEnd (Deprecated) Period end YYYY-MM-DD; fallback when period_year/period_month absent
     * @param limit Page size (default 100, max 500)
     * @param offset Page offset (default 0)
     * @returns reconciliation_SubsidyObligationListResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationSubsidyObligations(
        debtorAccountId: string,
        periodYear?: number,
        periodMonth?: number,
        includePaid?: boolean,
        status: 'all' | 'outstanding' | 'paid' = 'all',
        childInternalId?: string,
        periodStart?: string,
        periodEnd?: string,
        limit?: number,
        offset?: number,
    ): CancelablePromise<reconciliation_SubsidyObligationListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/subsidy-obligations',
            query: {
                'debtor_account_id': debtorAccountId,
                'period_year': periodYear,
                'period_month': periodMonth,
                'include_paid': includePaid,
                'status': status,
                'child_internal_id': childInternalId,
                'period_start': periodStart,
                'period_end': periodEnd,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * List a child's subsidy office person ids (PID)
     * Returns every live office person id of the child, one per office mapping, with its source: manual (entered by an operator) or name_exact (learned by the statement import).
     * @param childId Child id
     * @returns reconciliation_SubsidyOfficeChildRefListResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationSubsidyOfficeChildRefs(
        childId: string,
    ): CancelablePromise<reconciliation_SubsidyOfficeChildRefListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/subsidy-office-child-refs',
            query: {
                'child_id': childId,
            },
            errors: {
                400: `Missing or malformed child id`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Child not found`,
                429: `Rate limit exceeded`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Enter a child's subsidy office person id (PID)
     * Stores the office person id the operator entered for the child on one office, as a manual mapping. It replaces the child's other ids on that office; a statement import never overwrites it and flags a differing statement id on the checklist (pidMismatch). An id learned for another child by name is re-pointed; an id another child holds manually is refused with 409 SUBSIDY_OFFICE_CHILD_REF_TAKEN. Returns the child's ids afterwards.
     * @param request Child, office and person id
     * @returns reconciliation_SubsidyOfficeChildRefListResponse OK
     * @throws ApiError
     */
    public static putApiV1ReconciliationSubsidyOfficeChildRefs(
        request: reconciliation_SetSubsidyOfficeChildRefRequest,
    ): CancelablePromise<reconciliation_SubsidyOfficeChildRefListResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/reconciliation/subsidy-office-child-refs',
            body: request,
            errors: {
                400: `Malformed request body, or a blank or too long id`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Child or subsidy office not found`,
                409: `The id belongs to another child`,
                429: `Rate limit exceeded`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * List subsidy office reports covering a month
     * Returns every live report of the office that carries at least one line FOR the requested Bezugsmonat, with only those lines. The month is a property of the lines, not of the report header - a July tranche routinely settles a June difference. Each report also carries childMonths[], one entry per (child, Bezugsmonat) of the WHOLE statement with our split for it and a state of settled, open or no_split.
     * @param officeId Subsidy office id
     * @param referenceYear Bezugsjahr
     * @param referenceMonth Bezugsmonat (1-12)
     * @returns reconciliation_SubsidyOfficeReportListResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationSubsidyOfficeReports(
        officeId: string,
        referenceYear: number,
        referenceMonth: number,
    ): CancelablePromise<reconciliation_SubsidyOfficeReportListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/subsidy-office-reports',
            query: {
                'office_id': officeId,
                'reference_year': referenceYear,
                'reference_month': referenceMonth,
            },
            errors: {
                400: `Missing or invalid query parameter`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Upload a subsidy office report ("Abrechnung gemaess Auszahlung")
     * Multipart upload of the office's .xls/.xlsx settlement sheet. Parses the rows, resolves each to a child (learned office reference, then exact name), links the report to the matching office payment when exactly one is waiting, and stores the result.
     * @param file Office report (.xls or .xlsx, max 5 MB)
     * @param subsidyOfficeId Subsidy office the report belongs to
     * @param paymentId Payment to link the report to; omitted lets the server link it when unambiguous
     * @returns reconciliation_SubsidyOfficeReportDetailResponse Created
     * @throws ApiError
     */
    public static postApiV1ReconciliationSubsidyOfficeReports(
        file: Blob,
        subsidyOfficeId: string,
        paymentId?: string,
    ): CancelablePromise<reconciliation_SubsidyOfficeReportDetailResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/subsidy-office-reports',
            formData: {
                'file': file,
                'subsidyOfficeId': subsidyOfficeId,
                'paymentId': paymentId,
            },
            errors: {
                400: `Missing or malformed file / office id`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Subsidy office not found`,
                409: `This file was already imported`,
                413: `File exceeds 5 MB`,
                422: `File could not be read, or a required column is missing`,
                429: `Rate limit exceeded`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Delete a subsidy office report
     * Soft-deletes the report and its lines. The learned office-reference to child mappings survive: they belong to the office, not to the file that taught them.
     * @param id Report id
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1ReconciliationSubsidyOfficeReports(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/reconciliation/subsidy-office-reports/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Malformed report id`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Report not found`,
                429: `Rate limit exceeded`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Get one subsidy office report
     * Returns the report header with every line of the file, in sheet order. Each report also carries childMonths[], one entry per (child, Bezugsmonat) of the WHOLE statement with our split for it and a state of settled, open or no_split.
     * @param id Report id
     * @returns reconciliation_SubsidyOfficeReportDetailResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationSubsidyOfficeReports1(
        id: string,
    ): CancelablePromise<reconciliation_SubsidyOfficeReportDetailResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/subsidy-office-reports/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Malformed report id`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Report not found`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Adopt the office's rounded amounts for a linked statement
     * Administrator role required. For every child-month of a statement linked to a payment, writes an invoice subsidy correction (the subsidy_office/subsidy_amount override pin) so our split equals the office's figure, when the difference is within the organisation's subsidy_rounding_adoption_threshold_cents (inclusive). Skips a child-month above the threshold, with several splits, whose paid amount exceeds the office figure, on a closed invoice or on an invoice without a subsidy. A second run writes nothing. 409 SUBSIDY_REPORT_NOT_LINKED when no payment is linked; 409 SUBSIDY_ROUNDING_ADOPTION_DISABLED when the setting is off. An administrator's run then raises the statement's Sozialdepartement queue items as POST .../queue-items does, best effort.
     * @param id Report id
     * @returns reconciliation_SubsidyRoundingAdoptionResponse OK
     * @throws ApiError
     */
    public static postApiV1ReconciliationSubsidyOfficeReportsAdoptRounding(
        id: string,
    ): CancelablePromise<reconciliation_SubsidyRoundingAdoptionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/subsidy-office-reports/{id}/adopt-rounding',
            path: {
                'id': id,
            },
            errors: {
                400: `Malformed id`,
                401: `Authentication required`,
                403: `Caller is not an administrator, or organization ID not found in token`,
                404: `Report not found`,
                409: `Report not linked, superseded, or adoption disabled`,
                429: `Rate limit exceeded`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Link a subsidy office report to a payment
     * Links the report to an office bulk payment, or detaches it when paymentId is empty. The payment must sit on this office's own debtor account. A link by an administrator then raises the statement's Sozialdepartement queue items (missing, raise and release rows) as POST .../queue-items does; that step is best effort and never fails the link.
     * @param id Report id
     * @param request Payment to link, or empty to detach
     * @returns reconciliation_SubsidyOfficeReportDetailResponse OK
     * @throws ApiError
     */
    public static postApiV1ReconciliationSubsidyOfficeReportsAttachPayment(
        id: string,
        request: reconciliation_AttachSubsidyOfficeReportPaymentRequest,
    ): CancelablePromise<reconciliation_SubsidyOfficeReportDetailResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/subsidy-office-reports/{id}/attach-payment',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Malformed request body or id`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Report not found`,
                409: `The report was replaced by a newer upload`,
                422: `The payment is not on this subsidy office`,
                429: `Rate limit exceeded`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Export a statement's child-months as CSV
     * One row per child-month of the statement as the checklist shows it after netting (a Storno-only month is a row too), one row per line not matched to a child, and one row per open subsidy child-month of ours the statement does not carry (missing, or on another statement of the office). Columns: the statement's figures summed per child-month, Betrag next to our expected amount and the difference, the row state, the checklist state, the correction verdict and the invoice number. UTF-8 with BOM, semicolon separator, de-CH headers, amounts with two decimals and a dot. File name statement-<org>-<YYYY-MM>.csv (billing month).
     * @param id Report id
     * @returns binary OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationSubsidyOfficeReportsChildMonthsCsv(
        id: string,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/subsidy-office-reports/{id}/child-months.csv',
            path: {
                'id': id,
            },
            errors: {
                400: `Malformed id`,
                401: `Authentication required`,
                403: `Billing module required, or organization ID not found in token`,
                404: `Report not found`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Assign a report line to a child
     * Records the operator's pick for a line the matcher could not resolve, and learns the office's person id for that child so the next file resolves it without asking.
     * @param id Report id
     * @param lineId Report line id
     * @param request Child to assign
     * @returns reconciliation_SubsidyOfficeReportDetailResponse OK
     * @throws ApiError
     */
    public static patchApiV1ReconciliationSubsidyOfficeReportsLines(
        id: string,
        lineId: string,
        request: reconciliation_SetSubsidyOfficeReportLineChildRequest,
    ): CancelablePromise<reconciliation_SubsidyOfficeReportDetailResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/reconciliation/subsidy-office-reports/{id}/lines/{lineId}',
            path: {
                'id': id,
                'lineId': lineId,
            },
            body: request,
            errors: {
                400: `Malformed request body or id`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Report, line or child not found`,
                409: `The report was replaced by a newer upload`,
                422: `Validation failed`,
                429: `Rate limit exceeded`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Raise the Sozialdepartement queue items of a statement
     * Administrator role required. For every child-month the statement leaves missing (an open subsidy split of ours, no line on any live statement of the office) and every correction with the verdict raise or release, raises a subsidy_report item on the contract version of that month: kind mutation when the group's current version has a decision number, antrag otherwise, source statement. A row whose version already has an open item of that kind is added to it (once per statement and child-month). An approved item is not touched. Exact, rounding, differs, short, neutral and other_report rows raise nothing. 409 SUBSIDY_STATEMENT_UNRESOLVED_LINES while lines are not matched to a child (errors.count, errors.rows); 409 SUBSIDY_REPORT_SUPERSEDED for a replaced statement.
     * @param id Report id
     * @returns reconciliation_SubsidyStatementQueueResponse OK
     * @throws ApiError
     */
    public static postApiV1ReconciliationSubsidyOfficeReportsQueueItems(
        id: string,
    ): CancelablePromise<reconciliation_SubsidyStatementQueueResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/subsidy-office-reports/{id}/queue-items',
            path: {
                'id': id,
            },
            errors: {
                400: `Malformed id`,
                401: `Authentication required`,
                403: `Caller is not an administrator, or organization ID not found in token`,
                404: `Report not found`,
                409: `Unresolved lines, or the statement was superseded`,
                429: `Rate limit exceeded`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Subsidy office overview for a period
     * One row per live subsidy office with its subsidy ledger over the months: expected, paid, outstanding and the latest payment, plus a total row. A row equals the sum of the office's subsidy-ledger/monthly rows for the same period (invoices whose period lies inside the months). The office's debtor account is resolved from debtor_accounts.subsidy_office_id; an office without one lists with zeros and no debtorAccountId. childcare_id narrows to contracts of those locations. Not paginated.
     * @param periodStart First month (YYYY-MM)
     * @param periodEnd Last month, inclusive (YYYY-MM)
     * @param childcareId Childcare location ids, comma-separated (max 4000 characters)
     * @returns reconciliation_SubsidyOfficeSummaryResponseDTO OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationSubsidyOfficesSummary(
        periodStart: string,
        periodEnd: string,
        childcareId?: string,
    ): CancelablePromise<reconciliation_SubsidyOfficeSummaryResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/subsidy-offices/summary',
            query: {
                'period_start': periodStart,
                'period_end': periodEnd,
                'childcare_id': childcareId,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * List subsidy payment moves (ledger history)
     * Returns the move history, newest first, optionally filtered by child or office.
     * @param childId Filter by child id
     * @param fromOfficeId Filter by source office id
     * @param toOfficeId Filter by destination office id
     * @param status Filter by status (applied|reverted)
     * @returns reconciliation_MoveSubsidyPaymentListResponse OK
     * @throws ApiError
     */
    public static getApiV1ReconciliationSubsidyPaymentMoves(
        childId?: string,
        fromOfficeId?: string,
        toOfficeId?: string,
        status?: string,
    ): CancelablePromise<reconciliation_MoveSubsidyPaymentListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/subsidy-payment-moves',
            query: {
                'childId': childId,
                'fromOfficeId': fromOfficeId,
                'toOfficeId': toOfficeId,
                'status': status,
            },
            errors: {
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Move subsidy payment(s) to another office
     * Atomically moves the selected received payments from one subsidy office's account to another, re-applies the new office's credit onto the affected invoices' subsidy lines, and records a reversible batch.
     * @param request Move parameters
     * @returns reconciliation_MoveSubsidyPaymentResultResponse OK
     * @throws ApiError
     */
    public static postApiV1ReconciliationSubsidyPaymentMoves(
        request: reconciliation_MoveSubsidyPaymentRequest,
    ): CancelablePromise<reconciliation_MoveSubsidyPaymentResultResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/subsidy-payment-moves',
            body: request,
            errors: {
                400: `Invalid input`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Office not found`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Undo a subsidy payment move batch
     * Moves every still-applied payment in the batch back to the original office and re-settles the affected invoices on that office. Idempotent.
     * @param batchId Move batch ID
     * @param request Optional revert reason
     * @returns void
     * @throws ApiError
     */
    public static postApiV1ReconciliationSubsidyPaymentMovesRevert(
        batchId: string,
        request?: reconciliation_MoveSubsidyPaymentRevertRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/subsidy-payment-moves/{batchId}/revert',
            path: {
                'batchId': batchId,
            },
            body: request,
            errors: {
                400: `Invalid input`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Batch not found`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Preview moving subsidy payment(s) to another office
     * Read-only dry run that lists the received payments that will move, the total, and which invoices' office share will settle. Makes no DB writes.
     * @param request Move parameters
     * @returns reconciliation_MoveSubsidyPaymentPreviewResponse OK
     * @throws ApiError
     */
    public static postApiV1ReconciliationSubsidyPaymentMovesPreview(
        request: reconciliation_MoveSubsidyPaymentRequest,
    ): CancelablePromise<reconciliation_MoveSubsidyPaymentPreviewResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/subsidy-payment-moves/preview',
            body: request,
            errors: {
                400: `Invalid input`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Office not found`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * List subsidy office payments by queue status (active/ignored/credited)
     * Returns subsidy office payments for the requested queue tab (issue #761, Phase 3a).
     *
     * The 200 response schema is STATUS-DEPENDENT. swag cannot express a conditional/`oneOf` response, so the generated spec below shows only the DEFAULT (`status=active`) envelope — the actual shape per `status` is:
     * - `status=active` (default) → `PendingSubsidyPaymentListResponse`: routed-but-unapplied payments.
     * - `status=ignored` → `IgnoredSubsidyPaymentListResponse`: payments whose bank-transaction was ignored.
     * - `status=credited` → `CreditedSubsidyPaymentListResponse`: applied payments with their per-application allocation detail.
     *
     * Optional `office_id` filter narrows to a single office. Optional `search` substring filter matches the QR-reference, the bank-transaction remittance_info (a.k.a. "payment reference") and the displayed amount, mirroring the review-queue search.
     * @param status Queue tab: active (default), ignored, or credited
     * @param officeId Optional subsidy office filter
     * @param search Optional search substring (QR-reference, payment reference, or amount)
     * @param limit Page size (default 50, max 200)
     * @param offset Page offset (default 0)
     * @returns reconciliation_PendingSubsidyPaymentListResponse Default response shape (status omitted or status=active). swag emits THIS (last @Success wins) as the canonical 200; the status-dependent alternatives are documented above and in the description.
     * @throws ApiError
     */
    public static getApiV1ReconciliationSubsidyPayments(
        status?: 'active' | 'ignored' | 'credited',
        officeId?: string,
        search?: string,
        limit?: number,
        offset?: number,
    ): CancelablePromise<reconciliation_PendingSubsidyPaymentListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/reconciliation/subsidy-payments',
            query: {
                'status': status,
                'office_id': officeId,
                'search': search,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Apply a routed subsidy payment to one or more subsidy splits
     * Atomically writes payment_applications rows tagged `subsidy_split_apply`. A subsidy office's money is never parked as fungible account credit: creditRemainderToOffice and the on_account / remittance_level variance dispositions are refused with 422 for an office debtor, and any remainder stays on the payment.
     * @param id Payment ID
     * @param body Allocations + optional remainder credit flag
     * @returns reconciliation_ApplySubsidyPaymentResponse OK
     * @throws ApiError
     */
    public static postApiV1ReconciliationSubsidyPaymentsApply(
        id: string,
        body: reconciliation_ApplySubsidyPaymentRequest,
    ): CancelablePromise<reconciliation_ApplySubsidyPaymentResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/subsidy-payments/{id}/apply',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                412: `Precondition Failed`,
                422: `Office money cannot be parked as account credit`,
            },
        });
    }
    /**
     * Net an office reclaim against the payout it was withheld from
     * Administrator role required. Books a reclaimed child-month (Storno/Rekti) of a subsidy office as a pair of credit-only ledger rows: office_reclaim_out on the source payment and office_reclaim_in on the target payment (the path id), cross-linked and dated on the target. Both payments must sit on the same office debtor. The amount is bounded by the source's open amount and by the remaining negative net of that child-month on the target's linked statement. Payment amount, value date, bank transaction and remittance never change. Refused with 409 SUBSIDY_STATEMENT_UNRESOLVED_LINES while the cited statement has live lines not matched to a child (errors.count, errors.rows with the first five sheet rows). Undo through POST /reconciliation/office-reclaims/{applicationId}/revert.
     * @param id Target payment ID
     * @param body Netting request
     * @returns reconciliation_NetOfficeReclaimResponse OK
     * @throws ApiError
     */
    public static postApiV1ReconciliationSubsidyPaymentsNetReclaim(
        id: string,
        body: reconciliation_NetOfficeReclaimRequest,
    ): CancelablePromise<reconciliation_NetOfficeReclaimResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/subsidy-payments/{id}/net-reclaim',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Invalid identifier`,
                401: `Authentication required`,
                403: `Caller is not an administrator, or organization ID not found in token`,
                404: `Payment not found`,
                409: `A payment was modified concurrently, or the statement has lines not matched to a child (SUBSIDY_STATEMENT_UNRESOLVED_LINES with errors.count and errors.rows)`,
                422: `Validation failed, amount out of range, not an office payment, debtor mismatch, same payment, or invalid statement lines`,
                429: `Rate limit exceeded`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Revert an applied subsidy allocation (issue #761, Phase 3b)
     * Reverses the subsidy allocation of the payment the given application belongs to: restores invoice_splits.paid_amount + payments.unapplied_amount_cents, debits the office remainder credit, reverses the rounding-write-off correction, and returns the payment to the Active subsidy queue. Refuses with HTTP 409 + FIFODriftResponse when downstream rows have consumed the office credit.
     * @param id Payment ID
     * @param body Application to revert + operator reason
     * @returns reconciliation_RevertResponse OK
     * @throws ApiError
     */
    public static postApiV1ReconciliationSubsidyPaymentsRevert(
        id: string,
        body: reconciliation_RevertSubsidyApplicationRequest,
    ): CancelablePromise<reconciliation_RevertResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/subsidy-payments/{id}/revert',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                422: `Unprocessable Entity`,
            },
        });
    }
    /**
     * Write off a subsidy office payment's rounding remainder
     * Administrator role required — the whole /reconciliation group is owner-only (issue #906) and any other role gets 403. Closes a subsidy office payment whose open amount is within SUBSIDY_ROUNDING_TOLERANCE_CENTS with a coded reason. Writes one credit-only payment_applications row (match_source='payment_rounding_writeoff') and zeroes the payment's open amount. It never touches the office's credit pool (an office holds none), is refused for family debtors, and is reversible through the per-application Undo. The ceiling is per tranche (issue #1466): the flat tolerance, or 5 Rappen per line of the office statements linked to the payment when that is larger; an open amount above it is 422 ErrWriteOffRemainderOutOfRange. Read the effective ceiling from the Active rail's roundingWriteOffLimitCents rather than from the envelope's roundingToleranceCents.
     * @param id Payment ID
     * @param body Coded reason
     * @returns reconciliation_WriteOffSubsidyRemainderResponse OK
     * @throws ApiError
     */
    public static postApiV1ReconciliationSubsidyPaymentsWriteOffRemainder(
        id: string,
        body: reconciliation_WriteOffSubsidyRemainderRequest,
    ): CancelablePromise<reconciliation_WriteOffSubsidyRemainderResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reconciliation/subsidy-payments/{id}/write-off-remainder',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                403: `Caller is not an administrator, or organization ID not found in token`,
                404: `Not Found`,
                422: `Not an office payment, or remainder above tolerance`,
            },
        });
    }
}
